export default __webpack_public_path__ + "static/media/Pyramide-besoins_pro_n8_eternite.0f774e2a.svg";